import microuniversoApi from "app/api/microuniversoApi";
import { Abas } from "app/components/abas/Abas";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";

import {
  removerComponenteReact,
  renderizarComponentReact,
} from "app/components/renderizarOuRemoverComponentReact";
import { DadosAdicionaisComissoes } from "app/types/comissoes/DadosAdiconais";
import {
  Classificacao,
  Profissao,
} from "app/types/comissoes/DadosBasicosIndicadores";
import { Endereco } from "app/types/Endereco";
import { IEndereco } from "app/types/IEndereco";
import { Parametro } from "app/types/Parametro";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import clsx from "clsx";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react";
import { IIndicador } from "../../../types/IIndicador";
import { AbaDadosAdicionaisContainer } from "./aba-dados-adicionais/AbaDadosAdicionaisContainer";
import { AbaEnderecosContainer } from "./aba-enderecos/AbaEnderecosContainer";
import { NovoEnderecoComissoesContainer } from "./novo-endereco/NovoEnderecoComissoesContainer";
import { TelaComissoesContainer } from "../TelaComissoesContainer";
import * as R from "ramda";
import { FormikErrors } from "formik";
import { TelaDadosBasicosContainer } from "./TelaDadosBasicosContainer";
import { obterPermissao } from "app/use-cases/obterPermissao";

const estiloBotoes = require("./../../../estilos/botoes.module.scss").default;

type NomesAbas = "Dados Básicos" | "Endereços" | "Dados Adicionais";

export type TelaCadastroIndicadoresContainerProps = {
  abaSelecionada?: "Dados Básicos" | "Endereços" | "Dados Adicionais";
  codigoIndicador?: number;
};

export const TelaCadastroIndicadoresContainer = (
  props: TelaCadastroIndicadoresContainerProps
) => {
  const [abaSelecionada, setAbaSelecionada] = useState<NomesAbas>(
    props.abaSelecionada ?? "Dados Básicos"
  );
  const [classificacoes, setClassificacoes] = useState<Classificacao[]>();
  const [profissoes, setProfissoes] = useState<Profissao[]>();
  const [dadosAdicionais, setDadosAdicionais] =
    useState<DadosAdicionaisComissoes[]>();
  const [dadosIndicador, setDadosIndicador] = useState<IIndicador>();
  const [enderecosTemporarios, setEnderecosTemporarios] =
    useState<IEndereco[]>();
  const [enderecoAEditar, setEnderecoAEditar] = useState<Endereco>();
  const [exibeEditarEndereco, setExibeEditarEndereco] = useState(false);

  const [validarDadosBasicos, setValidarDadosBasicos] = useState(false);
  const [errosFormulario, setErrosFormulario] =
    useState<FormikErrors<IIndicador>>();
  const [formulariovalidado, setFormulariovalidado] = useState(false);

  const [enderecoBreadCrumb, setenderecoBreadCrumb] = useState("");
  const [parametros, setParametros] = useState<Parametro[]>([]);
  const [enderecosSelecionados, setEnderecosSelecionados] = useState<
    IEndereco[]
  >([]);
  const [podeSalvar, setPodeSalvar] = useState(false)

  const atualizarParametros = async () => {
    setParametros(
      await obterParametros({
        nomes: ["BAIRRO_NUMERO_OPCIONAL_CADASTRO_CLIENTE", "UTILIZAR_BAIRROS_PRE_CADASTRADOS"],
      })
    );
  };

  const permitidoAcaoFuncionalidade = async (
    siglaFuncionalidade: string,
    acao: string
  ) => await obterPermissao({ funcionalidade: siglaFuncionalidade, acao });

  const atualizaAcaoFuncionalidadeBotaoSalvar = async () => {
    setPodeSalvar(await permitidoAcaoFuncionalidade(
      "ORCAMENTO_INDICADORES",
      "ALTERAR"
    )
      ||
      await permitidoAcaoFuncionalidade(
        "ORCAMENTO_INDICADORES",
        "INCLUIR"
      ))
  }

  const valorParametro = (nome: string) =>
    parametros.find((p) => p.Nome == nome)?.Valor;

  const onRecuperarDadosIndicador = async (codigoIndicador: number) => {
    try {
      globalMU.blockUI();
      const dadosCadastroIndicador =
        await microuniversoApi.Orcamento.obterDadosCadastroIndicador(
          codigoIndicador
        );
      if (!("HasErrors" in dadosCadastroIndicador)) {
        setClassificacoes(dadosCadastroIndicador.Classificacoes);
        setProfissoes(dadosCadastroIndicador.Profissoes);
        setDadosAdicionais(dadosCadastroIndicador.DadosAdicionais);
        setDadosIndicador(dadosCadastroIndicador.ObterIndicador);
        setEnderecosTemporarios(
          dadosCadastroIndicador.ObterIndicador.Enderecos
        );

        dadosCadastroIndicador.Classificacoes?.length == 0 &&
          globalMU.showWarnMessage(
            "Não existe nenhum classificação para representante"
          );
      }
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onToggleEnderecoSelecionado = (endereco: IEndereco) => {
    if (enderecosSelecionados.includes(endereco)) {
      setEnderecosSelecionados(
        R.filter((e) => e != endereco, enderecosSelecionados)
      );
    } else {
      setEnderecosSelecionados(enderecosSelecionados.concat(endereco));
    }
  };

  const onManterDadosTemporariosDadosBasicos = (dadosTemporariosAtualizado) => {
    setDadosIndicador(dadosTemporariosAtualizado);
  };

  const onAtivaEditarEndereco = (ativa: boolean, endereco: Endereco) => {
    setEnderecoAEditar(endereco);
    setExibeEditarEndereco(ativa);
  };

  const onAdicionarEndereco = (endereco: Endereco) => {
    const copiaDeEnderecosTemporarios = Object.assign([], enderecosTemporarios);
    copiaDeEnderecosTemporarios.push(endereco);
    setEnderecosTemporarios(copiaDeEnderecosTemporarios);
  };

  const onEditarEndereco = (enderecoAEditar: Endereco) => {
    const copiaDeEnderecosTemporarios = enderecosTemporarios?.map((i) =>
      i.Codigo == enderecoAEditar.Codigo ? enderecoAEditar : i
    );
    setEnderecosTemporarios(copiaDeEnderecosTemporarios);
  };

  const onExcluirEnderecoTemporario = (enderecosSelecionados: Endereco[]) => {
    const endereco = enderecosTemporarios.filter(
      (e) => !enderecosSelecionados.some((i) => i.Codigo == e.Codigo)
    );
    setEnderecosTemporarios(endereco);
  };

  const onVoltar = () => {
    renderizarComponentReact(
      <TelaComissoesContainer />,
      "conteudo-pagina",
      true
    );
  };

  const onSalvarTodosDados = async () => {
    try {
      globalMU.blockUI();
      
      const copiaDeEnderecosTemporarios = enderecosTemporarios?.map((i) =>
        i.Codigo < 0 ? { ...i, Codigo: 0 } : i
      );
      
      const resultado = await microuniversoApi.Orcamento.salvarIndicador({
        ...dadosIndicador,
        Enderecos: copiaDeEnderecosTemporarios,
      });
      
      if (!("HasErrors" in resultado) && resultado != null) {
        setDadosIndicador(resultado);
        globalMU.showSuccessMessage("Indicador definido com sucesso.");
        onVoltar();
      }
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onAtualizarEnderecoBreadCrumb = () => {
    props.codigoIndicador == null
      ? setenderecoBreadCrumb("Cadastro Indicador")
      : setenderecoBreadCrumb("Editar Indicador");
  };

  useEffect(() => {
    onRecuperarDadosIndicador(props.codigoIndicador);
    onAtualizarEnderecoBreadCrumb();
    atualizarParametros();
    atualizaAcaoFuncionalidadeBotaoSalvar();
  }, []);

  return (
    <>
      {exibeEditarEndereco == false && (
        <>
          <Breadcrumb2Container
            id="TelaCadastroIndicadores_BreadcrumbCadastroIndicadores"
            passos={["Comissões", enderecoBreadCrumb]}
            onPassoSelecionado={(passo) => {
              if (passo == "Comissões") {
                onVoltar();
              }
              if (passo == "Editar Indicador") {
                onAtivaEditarEndereco(false, null);
              }
            }}
            exibirBotaoLimpar={false}
            exibirBotaoVoltar={true}
            onBotaoVoltarClicado={onVoltar}
          />

          <div className="_mt-2 _border-b _border-solid _border-[#ddd] _shadow-[0_6px_rgb(0_0_0/3%)]">
            <Abas
              abas={[
                { nome: "Dados Básicos" },
                { nome: "Endereços" },
                { nome: "Dados Adicionais" },
              ]}
              id="TelaCadastroIndicadorAbas"
              nomeAbaSelecionada={abaSelecionada}
              onAbaSelecionada={(nome) => setAbaSelecionada(nome as NomesAbas)}
            />
          </div>

          {abaSelecionada == "Dados Básicos" && (
            <TelaDadosBasicosContainer
              dadosIndicador={dadosIndicador}
              classificacoes={classificacoes}
              profissoes={profissoes}
              formularioValidado={formulariovalidado}
              podeSalvar={podeSalvar}
              manterDaodosTemporariosIndicador={
                onManterDadosTemporariosDadosBasicos
              }
              onValidarFormulario={setValidarDadosBasicos}
              onErrorValidacao={setErrosFormulario}
            />
          )}

          {abaSelecionada == "Endereços" && (
            <AbaEnderecosContainer
              tipoPessoa={dadosIndicador.TipoPessoa} // 441453
              enderecosSelecionados={enderecosSelecionados}
              onToggleEnderecoSelecionado={onToggleEnderecoSelecionado}
              codigoIndicador={props.codigoIndicador}
              onExcluirEnderecosTemporarios={onExcluirEnderecoTemporario}
              enderecos={enderecosTemporarios}
              cpfCnpj={dadosIndicador.CpfCnpj}
              onEditarEndereco={onAtivaEditarEndereco}
            />
          )}

          {abaSelecionada == "Dados Adicionais" && (
            <AbaDadosAdicionaisContainer
              listaDeDadosAdicionias={dadosAdicionais}
            />
          )}
        </>
      )}
      {exibeEditarEndereco && (
        <NovoEnderecoComissoesContainer
          utilizarBairrosPreCadastrados={valorParametro("UTILIZAR_BAIRROS_PRE_CADASTRADOS") === "S"}
          numeroEBairroObrigatorio={
            valorParametro("BAIRRO_NUMERO_OPCIONAL_CADASTRO_CLIENTE") !== "S"
          }
          clienteNaoCadastrado={false}
          editarEndereco={onEditarEndereco}
          adicionarEndereco={onAdicionarEndereco}
          endereco={enderecoAEditar}
          cpfCnpj={dadosIndicador.CpfCnpj}
          ativaEditarEndereco={onAtivaEditarEndereco}
        />
      )}

      {!exibeEditarEndereco && podeSalvar && (
        <button
          id="TelaCadastroIndicadoresContainer_BotaoSalvar"
          className={clsx("no-global-button _mt-2", estiloBotoes.botaoPrimario)}
          onClick={() => {
            validarDadosBasicos
              ? onSalvarTodosDados()
              : globalMU.showErrorMessage(errosFormulario);
            setFormulariovalidado(true);
          }}
        >
          Salvar
        </button>
      )}
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
